@if (!isLoading && !isUploaded) {
  <div class="upload-map-container">
    <div class="header">
      <h4 class="text-center">Map Import</h4>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closemodel(null)"><img
      src="assets/icons/icon-close.svg" alt=""></button>
    </div>
    <div class="map-up-content">
      <p>WorldTumbler supports maps created with Azgaar's Fantasy Map Generator (AFMG). AFMG can be both simple and very
        complex. For detailed guidance and advanced techniques, we recommend searching YouTube for AFMG tutorials to help
      in your world building.</p>
      <p><strong>VPN & Upload Issues:</strong> Using a VPN may cause map upload errors. If you encounter issues during
    upload, we recommend temporarily disabling your VPN and trying again.</p>
    <p><strong>City & Shantytown:</strong> Due to current import tooling, all cities must include a Shantytown. If a
    city does not have <em>Shantytown</em> selected in AFMG, WorldTumbler will automatically add one during import.
  </p>
  <p><strong>Early Access Notice:</strong> WorldTumbler is in <strong>early</strong> development and bugs /
limitations are to be expected. We appreciate your patience as features and stability continue to improve.</p>
<p>If you experience issues please contact <a href="mailto:support@worldtumbler.com" class="map-up-link">support&#64;worldtumbler.com</a> or find us on Discord.</p>
</div>
<form [formGroup]="addmapdata" enctype="multipart/form-data" (ngSubmit)="onSubmit()">
  <h5>SELECT FILE</h5>
  <div class="add-group">
    <div class="add-gtop">
      <label class="form-label">Map Name</label>
      <input type="text" formControlName="map_name" class="form-control" />
    </div>
    @if (addmapdata.controls['map_name'].hasError('required') &&
      (addmapdata.controls['map_name'].dirty ||
      addmapdata.controls['map_name'].touched || submitted)) {
      <span class="error-message mb-2">
        Map Name is Required
      </span>
    }
  </div>
  <div class="add-group mb-3 mt-3">
    <div class="acc-card-group acc-contenttype w-100">
      <div class="lbname">Map Genre</div>
      <ng-select class="wt-select" formControlName="map_genre" [items]="mapGenreList"
        bindValue="label" bindLabel="label" placeholder="Select Map Genre" [clearable]="false" appendTo="body">
        <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Select Map Genre' }}</span></ng-template>
      </ng-select>
    </div>
    @if (addmapdata.controls['map_genre'].hasError('required') &&
      (addmapdata.controls['map_genre'].dirty ||
      addmapdata.controls['map_genre'].touched || submitted)) {
      <span class="error-message mb-2">
        Map Genre is Required
      </span>
    }
  </div>
  <div class="add-group">
    <div class="add-gtop">
      <label class="form-label">Upload Map (.map)</label>
      <input type="file" formControlName="map_file" accept=".map" (change)="handleFileInput($event)"
        class="form-control" />
      </div>
      @if (addmapdata.controls['map_file'].hasError('required') &&
        (addmapdata.controls['map_file'].dirty ||
        addmapdata.controls['map_file'].touched || submitted)) {
        <span class="error-message mb-2">
          Map File is Required
        </span>
      }
    </div>
    <div class="add-group mt-3">
      <div class="add-gtop">
        <label class="form-label">Upload JSON (.json)</label>
        <input type="file" formControlName="json_file" accept=".json" (change)="handleJsonFileInput($event)"
          class="form-control" />
        </div>
        @if (addmapdata.controls['json_file'].hasError('required') &&
          (addmapdata.controls['json_file'].dirty ||
          addmapdata.controls['json_file'].touched || submitted)) {
          <span class="error-message mb-2">
            JSON File is Required
          </span>
        }
      </div>
      <div class="btn-sec">
        <button class="btn btn-theme d-flex align-items-center justify-content-center" [disabled]="isLoading"
          type="submit">
          Upload
        </button>
      </div>
    </form>
    <div class="map-up-btm">
      <div class="map-up-btm-text">
        !! Please support these creators !!
      </div>
      <!-- Azgaar -->
      <div class="map-up-btm-text">
        <span>Azgaar's Fantasy Map Generator</span>
        <span>
          <a href="https://azgaar.github.io/Fantasy-Map-Generator/" target="_blank">
            <img src="assets/icons/icon-link-tool.png" alt="Website Link">
          </a>
        </span>
        <span>
          <a href="https://www.patreon.com/azgaar" target="_blank">
            <img src="assets/icons/icon-patreon.png" alt="Patreon">
          </a>
        </span>
      </div>
      <!-- Watabou -->
      <div class="map-up-btm-text">
        <span>Watabou's Procgen Arcana</span>
        <span>
          <a href="https://watabou.github.io/" target="_blank">
            <img src="assets/icons/icon-link-tool.png" alt="Website Link">
          </a>
        </span>
        <span>
          <a href="https://www.patreon.com/watawatabou" target="_blank">
            <img src="assets/icons/icon-patreon.png" alt="Patreon">
          </a>
        </span>
      </div>
    </div>
  </div>
}


@if (isLoading || isUploaded) {
  <div class="upload-map-container">
    <div class="header">
      <h4>Your map is being uploaded!</h4>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closemodel(isUploaded)"
        [disabled]="isLoading"><img src="assets/icons/icon-close.svg" alt=""></button>
      </div>
      <div class="map-up-content">
        @if (isUploaded && !isLoading) {
          <p>Map geography uploads quickly, resources, wiki and city maps will populate in
            the next few hours depending on size
          </p>
        }
        @if (!isUploaded) {
          <div class="loading-container d-flex align-items-center flex-column justify-content-center">
            <div class="spinner"></div>
            <p>Uploading</p>
          </div>
        }
        <p>VERY IMPORTANT - Please keep a copy of your uploaded file.</p>
        <p>Future improvements may require the original map</p>
      </div>
      <div class="map-up-btm">
        <div class="map-up-btm-text">
          !! Please support these creators !!
        </div>
        <div class="map-up-btm-text">
          <span>Azgaar's Fantasy Map Generator</span>
          <span><img src="assets/icons/icon-link-tool.png" alt=""></span>
          <span><img src="assets/icons/icon-patreon.png" alt=""></span>
        </div>
        <div class="map-up-btm-text">
          <span>Watabou's Procgen Arcana</span>
          <span><img src="assets/icons/icon-link-tool.png" alt=""></span>
          <span><img src="assets/icons/icon-patreon.png" alt=""></span>
        </div>
      </div>
    </div>
  }